import React, { useRef } from 'react';
import './giftsHeader.css';
import { useDispatch, useSelector } from "react-redux";
import {
    dropdownAction,
    filterUserAction,
    filterWindowAction,
    giftFormAction,
    giftsStatusFilterAction,
    resetAllFiltersAction
} from "../../../redux/rootReducer";
import { GIFT_FORM_INITIAL } from "../../../redux/initialStateConstant";
import { getGiftsOrdersSagaAction, getUsersForSubscriptionSagaAction } from "../../../redux/sagaActions";
import FilterSelect from "../../FilterSelect/FilterSelect";
import Toggle from "../../Toggle/Toggle";
import FiltersWrapper from "../../FiltersWrapper/FiltersWrapper";

const GiftsHeader = ({ page, setPage }) => {
    const dispatch = useDispatch();
    const dropdown = useSelector(state => state.dropdown);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const giftsStatusFilterOptions = useSelector(state => state.giftsStatusFilterOptions);
    const filterUser = useSelector(state => state.filterUser);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            // Получение списка пользователей, удовлетворяющих введённым данным (имя, телефон, почта)
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'filter' }));
        }, 500);
    };

    return (
        <>
            <Toggle active={ page } setHandler={ setPage } captionLeft={ 'Заказы' } captionRight={ 'Настройки' }/>
            {
                !page
                    ?
                    <div className="button button--add"
                         onClick={ () => dispatch(giftFormAction({ ...GIFT_FORM_INITIAL, open: true })) }
                    >Добавить бонус</div>
                    :
                    <div className="gifts__filter">
                        <FiltersWrapper>
                            <div className="flt__content">
                                <div className="flt__reset" onClick={ () => {
                                    // Сброс фильтров
                                    dispatch(resetAllFiltersAction());
                                } }>Сбросить фильтры</div>
                                <div className="flt__caption">Фильтры</div>
                                <div className="dropdown">
                                    <div className="filter filter--input">
                                        <input className="filter__input"
                                               placeholder={ 'Посетитель' }
                                               value={ filterUser.user.name }
                                               onInput={ event => {
                                                   dispatch(filterUserAction({
                                                       ...filterUser,
                                                       user: {
                                                           id: '',
                                                           name: event.target.value
                                                       }
                                                   }));
                                                   // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                                   getUsers(event.target.value);
                                               } }
                                        />
                                        {
                                            filterUser.user.id || filterUser.user.name
                                                ? <div className="filter__remove" onClick={ event => {
                                                    event.stopPropagation();
                                                    dispatch(filterUserAction({ ...filterUser, user: { id: '', name: '' } }));
                                                } } />
                                                : false
                                        }
                                    </div>
                                    <div className={ `dropdown__items ${ dropdown === 'filter_user' ? 'dropdown__items--open' : '' }` }>
                                        {
                                            filterUser.users.map(elem => {
                                                return (
                                                    <div className="dropdown__item" key={ elem.id }
                                                         onClick={ () => {
                                                             dispatch(filterUserAction({
                                                                 ...filterUser,
                                                                 user: { id: elem.id, name: elem.name }
                                                             }));
                                                             dispatch(dropdownAction(null));
                                                         } }
                                                    >{ `${ elem.name } ${ elem.phone }` }</div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="select__wrapper">
                                    <FilterSelect
                                        options={ giftsStatusFilterOptions }
                                        handler={ id => {
                                            dispatch(giftsStatusFilterAction(giftsStatusFilterOptions.map(elem => {
                                                // Меняем состояние выбранных элементов
                                                if (elem.id === id) return { ...elem, active: !elem.active };
                                                else return elem;
                                            })));
                                        } }
                                        placeholder={ 'Статус заказа' }
                                        open={ dropdown === 'filter_gifts_order_status' }
                                        openHandler={ () => dispatch(dropdownAction('filter_gifts_order_status')) }
                                        clear={ () => dispatch(giftsStatusFilterAction(giftsStatusFilterOptions.map(elem => {

                                            if (elem.active) return { ...elem, active: !elem.active };
                                            else return elem;
                                        }))) }
                                    />
                                </div>
                                <div className="button button--blue"
                                     onClick={ () => {
                                         // Закрываем фильтры
                                         dispatch(filterWindowAction(false));
                                         // Запрашиваем список заказанных бонусов, для указанного пользователя
                                         dispatch(getGiftsOrdersSagaAction({
                                             establishment: currentEstablishment,
                                             page: 1,
                                             user: filterUser.user.id,
                                             status: JSON.stringify(giftsStatusFilterOptions.filter(el => el.active).map(el => el.id))
                                         }));
                                     } }
                                >Применить</div>
                            </div>
                        </FiltersWrapper>
                    </div>
            }
        </>
    );
};

export default GiftsHeader;